/**
 * Das "nextTask" Array kann mehrere Elemente haben.
 * Welcher Index genutzt wird, entscheidet je die Komponente. zB P1-10.vue, P2-10.vue usw.
 * Beschreibung dazu in der miro Tabelle
 */

const schedules = {
  'P1-10': {
    visibleTasks: {
      relevant: ['P1-10', 'P2-10'],
      optional: ['P1-20', 'P1-30', 'P1-40', 'P1-50', 'P1-70'],
    },
    nextTask: ['P2-10', 'P1-70'], // yes P2-10, no: P1-70
  },
  'P1-70': {
    visibleTasks: {
      // Wenn "Nein" in "Pflegebedürftigkeit erkennen" [P1-10]
      // ausgewählt wird, fühgt die relevantTasks() (computed) property noch [P2-10] hinzu.
      // also: relevant: ['P1-70', 'P1-80', 'P2-10'],
      relevant: ['P1-70', 'P1-80'],
      optional: null,
    },
    nextTask: ['P1-80'],
  },
  'P1-80': {
    visibleTasks: {
      relevant: ['P1-80', 'P2-10'],
      optional: null,
    },
    nextTask: ['P2-10'],
  },
  'P2-10': {
    visibleTasks: {
      relevant: ['P2-10'],
      optional: ['P1-20', 'P1-30', 'P1-40', 'P1-50', 'P1-70'],
    },
    nextTask: ['P2-20', 'P1-70'], // yes P2-20, no: P1-70
  },
  'P2-20': {
    visibleTasks: {
      relevant: ['P2-20'],
      optional: ['P1-20', 'P1-30', 'P1-40', 'P1-50', 'P1-70'],
    },
    nextTask: ['P2-30'],
    required: ['P2-10'],
  },
  'P2-30': {
    visibleTasks: {
      relevant: ['P2-30', 'P2-40'],
      optional: ['P1-20', 'P1-40', 'P1-50', 'P1-70'],
    },
    nextTask: ['P2-40'],
    required: ['P2-20'],
  },
  'P2-40': {
    visibleTasks: {
      relevant: ['P2-40'],
      optional: ['P3-10', 'P1-60', 'P1-20', 'P1-40', 'P1-50', 'P1-70'],
    },
    nextTask: ['P3-20', 'P2-50'], // yes P3-20, no P2-50
    required: ['P2-20'],
  },
  'P2-50': {
    visibleTasks: {
      relevant: ['P2-50'],
      optional: ['P1-70'],
    },
    nextTask: ['P2-60', 'P1-70', 'P3-20'], // Ablehnung nicht nachvollziehbar P2-60, Ablehnung nachvollziehbar (ohne PG) P1-70, , Ablehnung nachvollziehbar (mit PG) P3-20
    required: ['P2-40'],
  },
  'P2-60': {
    visibleTasks: {
      relevant: ['P2-60'],
      optional: ['P1-70'],
    },
    nextTask: ['P2-70'],
    required: ['P2-50'],
  },
  'P2-70': {
    visibleTasks: {
      relevant: ['P2-70'],
      optional: ['P1-70'],
    },
    nextTask: ['P3-20', 'P1-70', 'P3-20'], // Ja P3-20, Nein (wenn noch kein PG) P1-70, Nein (wenn PG vorhanden) P3-20
    required: ['P2-60'],
  },
  'P3-20': {
    visibleTasks: {
      relevant: ['P3-20'],
      optional: ['P3-10', 'P4-10'],
    },
    nextTask: ['P3-30'],
    required: ['P2-40'],
  },
  'P3-30': {
    visibleTasks: {
      relevant: ['P3-30'],
      optional: ['P3-10', 'P4-10'],
    },
    nextTask: ['P4-20'], // Nach 8 Monaten
    required: ['P3-20'],
  },
  'P4-20': {
    visibleTasks: {
      relevant: ['P4-20', 'P4-30'],
      optional: ['P3-10', 'P4-10'],
    },
    nextTask: ['P4-30'],
    required: ['P3-20'],
  },
  'P4-30': {
    visibleTasks: {
      relevant: ['P4-30'],
      optional: ['P3-10', 'P4-10'],
    },
    nextTask: null,
    required: ['P3-20'],
  },
};

export default schedules;
